import { usePlayer } from '../player/store';

/**
 * Logo PUJOLiSIQUE : casque vert, disque or, note grenat.
 * Les verts suivent le thème (plus lumineux sur fond sombre).
 */
export function LogoMark({ className = '' }: { className?: string }) {
  return (
    <svg className={`logo ${className}`} viewBox="390 135 485 410" aria-hidden focusable="false">
      <circle cx="632" cy="374" r="132" fill="#D9AC3A" />
      <path className="logo__band" d="M460,372 L460,355 A172,193 0 0 1 804,355 L804,372" fill="none" strokeWidth="28" />
      <path className="logo__line" d="M515.56,244.44 A152,172 0 0 1 748.44,244.44" fill="none" strokeWidth="15" strokeLinecap="round" />
      <rect className="logo__cup" x="403" y="345" width="76" height="152" rx="30" />
      <rect className="logo__cup" x="786" y="345" width="76" height="152" rx="30" />
      <line className="logo__line" x1="455" y1="352" x2="455" y2="490" strokeWidth="3" />
      <line className="logo__line" x1="810" y1="352" x2="810" y2="490" strokeWidth="3" />
      <circle cx="664" cy="352" r="30" fill="#7E171D" />
      <path
        d="M570,306 L597,306 C640,318 678,345 678,385 C678,425 662,452 640,479 C656,440 656,405 641,386 C628,370 611,362 597,358 L597,500 L570,500 Z"
        fill="#9C2228"
      />
      <ellipse cx="550" cy="505" rx="47" ry="36" transform="rotate(-28 550 505)" fill="#8A1C22" />
    </svg>
  );
}

/**
 * PUJOLi en vert, SIQUE en or, comme sur le logo.
 * Le point du « i » devient or et bat doucement pendant la lecture.
 */
export function Wordmark({ compact }: { compact?: boolean }) {
  const playing = usePlayer((s) => s.playing);
  return (
    <span className={`wordmark ${compact ? 'wordmark--compact' : ''}`} aria-label="PUJOLiSIQUE">
      <span className="wordmark__a" aria-hidden>
        PUJOL
      </span>
      <span className="wordmark__i" aria-hidden>
        ı<span className={`wordmark__dot ${playing ? 'is-playing' : ''}`} />
      </span>
      <span className="wordmark__b" aria-hidden>
        SIQUE
      </span>
    </span>
  );
}

/** Logo et nom côte à côte (barre latérale, barre haute sur mobile) */
export function Brand({ compact }: { compact?: boolean }) {
  return (
    <span className="brand">
      <LogoMark />
      <Wordmark compact={compact} />
    </span>
  );
}
